module.exports = __webpack_public_path__ + "img/Naval_Ensign_of_Honduras.d7a738e8.svg";